import { render } from "./AssessmentReport.vue?vue&type=template&id=8ef50bee&scoped=true"
import script from "./AssessmentReport.vue?vue&type=script&lang=js"
export * from "./AssessmentReport.vue?vue&type=script&lang=js"

import "./AssessmentReport.vue?vue&type=style&index=0&id=8ef50bee&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1728185854/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ef50bee"]])

export default __exports__